import Vue from 'vue'

// import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

if(process.browser) {
    const VueAwesomeSwiper = require('vue-awesome-swiper');
    Vue.use(VueAwesomeSwiper);
}